import { $t } from '@previo/core'

const codebook_t = $t

export { codebook_t as $t }
